import { Component } from '@angular/core';

@Component({
  selector: 'sh-platform-message',
  templateUrl: './platform-message.component.html',
  styleUrl: './platform-message.component.scss',
  standalone: false
})
export class PlatformMessageComponent {
  usage = `
        <ui-platform-message
          [messageCode]="'profile.admin.esg.disclosure.locked-client'"
          [type]="'danger'"
          [hasCloseBtn]="true"
        >
          <ui-platform-button
            [type]="'primary'"
            [label]="'CTA'">
          </ui-platform-button>
        </ui-platform-message>

        <ui-platform-message
          [messageCode]="'profile.admin.esg.disclosure.locked-client'"
          [type]="'danger'"
        ></ui-platform-message>
    `;

  import = `
    import {UiPlatformMessageModule} from 'ui-platform';
  `;
}
